import dayjs from 'dayjs'

export default {
    props: {
        year: { type: Number, required: true },
        month: { type: Number, required: true },
        day: { type: Number, required: true },
        slotsCount: { type: Number, default: 0 },
        physician: { type: Object, required: true },
        practice: { type: Object, required: true },
    },

    data() {
        return {
            isSlotsTooltipOpen: false,
        }
    },

    computed: {
        date() {
            return dayjs().year(this.year).month(this.month).date(this.day).startOf('day')
        },

        elementProps() {
            return {
                is: this.hasAvailableSlots ? 'button' : 'div',
                class: this.dayClass,
            }
        },

        dayClass() {
            return {
                'appointment-calendar-day': true,
                'appointment-calendar-day--is-current': this.isToday,
                'appointment-calendar-day--has-slots': this.hasAvailableSlots,
                'appointment-calendar-day--is-open': this.isSlotsTooltipOpen,
            }
        },
    },

    methods: {
        closeSlotsTooltip() {
            if (this.isDescendant(event.target, document.getElementsByClassName('vue-portal-target')[0])) {
                return
            }

            this.isSlotsTooltipOpen = false
        },

        toggleSlotsTooltip(event) {
            if (this.isDescendant(event.target, this.$refs.tooltip)) {
                return
            }

            this.isSlotsTooltipOpen = this.hasAvailableSlots && !this.isSlotsTooltipOpen
        },
    },
}
